import { render } from "./ReportStaffPerformance.vue?vue&type=template&id=8a722198&scoped=true"
import script from "./ReportStaffPerformance.vue?vue&type=script&lang=js"
export * from "./ReportStaffPerformance.vue?vue&type=script&lang=js"

import "./ReportStaffPerformance.vue?vue&type=style&index=0&id=8a722198&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a722198"]])

export default __exports__